import axios from "axios";

//export const baseURL = "https://lms.raphaedu.com/backend/api"; // Default: production
//export const baseURL = "http://localhost:8000/api"; // Local development
export const baseURL =
  process.env.REACT_APP_BASE_HOST_URL || "http://localhost:8000/api";
const instance = axios.create({
  baseURL,
});

// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    const token =
      localStorage.getItem("studentToken") ||
      localStorage.getItem("examinerToken") ||
      localStorage.getItem("adminToken") ||
      localStorage.getItem("facultyToken") ||
      localStorage.getItem("userToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export function clearAuthTokens() {
  localStorage.removeItem("userToken");
  localStorage.removeItem("studentToken");
  localStorage.removeItem("adminToken");
  localStorage.removeItem("facultyToken");
  localStorage.removeItem("examinerToken");
  localStorage.removeItem("isAdmin");
}

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      // Token is invalid or expired
      clearAuthTokens();
      // Redirect to login page
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

export const examinerLoginAPI = async (userData) => {
  try {
    const response = await instance.post("/examiner/login", userData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAtktCatalogAPI = async () => {
  try {
    const response = await instance.get("/atkt/catalog");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const submitAtktFormAPI = async (formData) => {
  try {
    const response = await instance.post("/atkt/forms", formData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAtktFormsAPI = async (filters = {}) => {
  try {
    const response = await instance.get("/atkt/forms", {
      params: filters,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAtktStatusAPI = async () => {
  try {
    const response = await instance.get("/atkt/status");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const toggleAtktStatusAPI = async () => {
  try {
    const response = await instance.put("/atkt/status");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getMyAtktFormAPI = async () => {
  try {
    const response = await instance.get("/atkt/my-form");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateAtktFormAPI = async (id, updates) => {
  try {
    const response = await instance.put(`/atkt/forms/${id}`, updates, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteAtktFormAPI = async (id) => {
  try {
    const response = await instance.delete(`/atkt/forms/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAtktBatchNamesAPI = async () => {
  try {
    const response = await instance.get("/atkt/batch-names");
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const downloadAtktHallTicketAPI = async (formId) => {
  try {
    const response = await instance.get(`/atkt/forms/${formId}/hall-ticket`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const bulkDownloadAtktHallTicketsAPI = async (filters = {}) => {
  try {
    const response = await instance.get('/atkt/forms/bulk-download-hall-tickets', {
      params: filters,
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const changeStudentPassword = async ({
  currentPassword,
  newPassword,
}) => {
  return instance.post("/students/change-password", {
    currentPassword,
    newPassword,
  });
};

export const registerAPI = async (userData) => {
  try {
    const response = await instance.post("/user/register", userData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const loginAPI = async (userData) => {
  try {
    const response = await instance.post("/user/login", userData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// student API - FIXED: Changed from /students to /student
export const studentLoginAPI = async (userData) => {
  try {
    const response = await instance.post("/students/login", userData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// User forgot password
export const forgotPassAPI = async (userData) => {
  try {
    const response = await instance.post("/user/forgot-password", userData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Student forgot password - FIXED: Changed from /students to /student
export const forgotStudentPassAPI = async (userData) => {
  try {
    const response = await instance.post(
      "/students/forgot-password",
      userData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
// form
export const submitStep1 = async (userData) => {
  try {
    const response = await instance.post(
      "/form/register-application",
      userData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getFormLists = async (userData) => {
  try {
    const response = await instance.get("/form/get-applications", {
      params: userData,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getProgramByName = async (programName) => {
  try {
    const response = await instance.get(`/program/fee-by-name/${programName}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getSingleFormData = async (id) => {
  try {
    const response = await instance.get(`/form/get-single-application/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateApplicationForm = async (userData) => {
  try {
    const response = await instance.post("/form/update-application", userData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// admin routes
export const getFormListsForAdmin = async (userData) => {
  try {
    const response = await instance.get("/form/get-applications-for-admin", {
      params: userData,
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getSingleFormDataForAdmin = async (id) => {
  try {
    const response = await instance.get(
      `/form/get-single-application-for-admin/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const submitStep1ForAdmin = async (userData) => {
  try {
    const response = await instance.post(
      "/form/register-application",
      userData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateApplicationFormForAdmin = async (userData) => {
  try {
    const response = await instance.post("/form/update-application", userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// leads
export const createLeadCaptureLinkViaAdmin = async (userData) => {
  try {
    const response = await instance.post("/lead/create-new-link", userData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAllLinkViaAdmin = async (userData) => {
  try {
    const response = await instance.get("/lead/get-all-links", {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSingleLinkViaAdmin = async (userData) => {
  try {
    const response = await instance.get(`/lead/get-link/${userData.id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const UpdateLinkViaAdmin = async (userData) => {
  try {
    const response = await instance.put(
      `/lead/update-link/${userData.id}`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteLinkViaAdmin = async (userData) => {
  try {
    const response = await instance.delete(`/lead/delete-link/${userData.id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSingleLinkForLandingWithIdAndUniqueId = async (userData) => {
  try {
    const response = await instance.get(
      `/lead/get-link-with-id-unique/${userData.id}/${userData.uniqueId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getFormListsForAdminFilters = async (
  filters = {},
  { page = 1, limit = 10, includeIds = false } = {},
) => {
  try {
    const response = await instance.post(
      "/form/get-applications-for-admin-filters",
      { ...filters, page, limit, includeIds },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// razorpay
export const getRazorPayACCKey = async () => {
  try {
    const response = await instance.post(
      `/payments/get-key`,
      {}, // Empty body for POST request
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("userToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getRazorPayACCKeyStudent = async () => {
  try {
    const response = await instance.get(`/payments/get-key-student`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createCheckoutOfRazorPay = async (userData) => {
  try {
    const response = await instance.post(
      `/payments/create-checkout`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("userToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getApplicationPaymentStatus = async (applicationId) => {
  try {
    const response = await instance.get(
      `/payments/status/application/${applicationId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("userToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyHostedPayment = async (userData) => {
  try {
    const response = await instance.post(
      `/payments/verify-hosted-payment`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("userToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const capturePaymentOfRazorPay = async (userData) => {
  try {
    const response = await instance.post(
      `/payments/capture-payment`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("userToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// landing page
export const captureLead = async (userData) => {
  try {
    const response = await instance.post(
      `/landing/capture-landing-page-lead`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAdmissionLeadsForAdmin = async (userData) => {
  try {
    const response = await instance.post(
      `/landing/get-all-landing-page-leads`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ----------------------------------------
export const createDepartmentViaAdmin = async (userData) => {
  try {
    const response = await instance.post(
      "/department/create-new-department",
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllDepartmentsViaAdmin = async (userData) => {
  try {
    const response = await instance.get("/department/get-all-departments", {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteDepartmentViaAdmin = async (userData) => {
  try {
    const response = await instance.delete(
      `/department/delete-a-department/${userData.id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const UpdateDepartmentViaAdmin = async (userData) => {
  try {
    const response = await instance.put(
      `/department/update-a-department/${userData.id}`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getSingleDepartmentViaAdmin = async (userData) => {
  try {
    const response = await instance.get(
      `/department/get-department/${userData.id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

//-----------------------
export const createProgramViaAdmin = async (userData) => {
  try {
    const response = await instance.post(
      "/program/create-new-program",
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAllProgramsViaAdmin = async () => {
  try {
    const response = await instance.get("/program/get-all-programs", {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteProgramViaAdmin = async (userData) => {
  try {
    const response = await instance.delete(
      `/program/delete-a-program/${userData.id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const UpdateProgramViaAdmin = async (userData) => {
  try {
    const response = await instance.put(
      `/program/update-a-program/${userData.id}`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSingleProgramViaAdmin = async (userData) => {
  try {
    const response = await instance.get(`/program/get-program/${userData.id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const checkProgramCapacity = async (programName) => {
  try {
    const response = await instance.get(`/program/is-full/${programName}`);
    return response.data.isFull;
  } catch (error) {
    console.error("Error checking program capacity:", error);
    return false;
  }
};

//-----------------
export const createBatchViaAdmin = async (userData) => {
  try {
    const response = await instance.post("/batch/create-new-batch", userData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllBatchesViaAdmin = async (userData) => {
  try {
    const response = await instance.get("/batch/get-all-batches", {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteBatchViaAdmin = async (userData) => {
  try {
    console.log(userData.id);
    const response = await instance.delete(
      `/batch/delete-a-batch/${userData.id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const UpdateBatchViaAdmin = async (userData) => {
  try {
    const response = await instance.put(
      `/batch/update-a-batch/${userData.id}`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSingleBatchViaAdmin = async (userData) => {
  try {
    const response = await instance.get(`/batch/get-batch/${userData.id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const promoteBatchById = async (userData) => {
  try {
    const response = await instance.put(
      `/batch/promote-batch/${userData.id}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const demoteBatchById = async (userData) => {
  try {
    const response = await instance.put(
      `/batch/demote-batch/${userData.id}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

//-----------------------
// similar add update delete faculty
export const facultyLoginAPI = async (userData) => {
  try {
    const response = await instance.post("/faculty/login", userData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const facultyForgotPassAPI = async (userData) => {
  try {
    const response = await instance.post("/faculty/forgot-password", userData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createFacultyViaAdmin = async (userData) => {
  try {
    console.log(userData);
    const response = await instance.post(
      "/faculty/create-new-faculty",
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAllFacultiesViaAdmin = async (userData) => {
  try {
    const response = await instance.get("/faculty/get-all-faculties", {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    // Ensure the return value is always { faculties: [...] } with facultyName property
    let faculties = [];
    if (Array.isArray(response.data)) {
      faculties = response.data;
    } else if (Array.isArray(response.data.faculties)) {
      faculties = response.data.faculties;
    } else if (Array.isArray(response.data.data)) {
      faculties = response.data.data;
    }
    // Fallback: filter only those with facultyName property
    faculties = faculties.filter((f) => f.facultyName);
    return { faculties };
  } catch (error) {
    throw error;
  }
};
export const deleteFacultyViaAdmin = async (userData) => {
  try {
    const response = await instance.delete(
      `/faculty/delete-a-faculty/${userData.id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const UpdateFacultyViaAdmin = async (userData) => {
  try {
    const response = await instance.put(
      `/faculty/update-a-faculty/${userData.id}`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getSingleFacultyViaAdmin = async (userData) => {
  try {
    const response = await instance.get(`/faculty/get-faculty/${userData.id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const mailFacultyLoginDetailsViaAdmin = async (id) => {
  try {
    const response = await instance.post(
      `/faculty/mail-details-faculty/${id}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

//-----------------------------
// similar add update delete subject
export const createSubjectViaAdmin = async (userData) => {
  try {
    const response = await instance.post(
      "/subject/create-new-subject",
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAllSubjectsViaAdmin = async (userData) => {
  try {
    const response = await instance.get("/subject/get-all-subjects", {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const deleteSubjectViaAdmin = async (userData) => {
  try {
    const response = await instance.delete(
      `/subject/delete-a-subject/${userData.id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const UpdateSubjectViaAdmin = async (userData) => {
  try {
    const response = await instance.put(
      `/subject/update-a-subject/${userData.id}`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getSingleSubjectViaAdmin = async (userData) => {
  try {
    const response = await instance.get(`/subject/get-subject/${userData.id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const downloadSubjectsCSVViaAdmin = async () => {
  try {
    const response = await instance.get("/subject/download-csv", {
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

//----------------------------------------
// similar add update delete grade
export const createGradeSchemeViaAdmin = async (userData) => {
  // Only send allowed fields: program, gradeSchemeName, grades
  const payload = {
    program: userData.program,
    gradeSchemeName: userData.gradeSchemeName,
    grades: userData.grades,
  };
  try {
    const response = await instance.post("/grade/create-new-scheme", payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const addGradeToSchemeViaAdmin = async (userData) => {
  try {
    const response = await instance.post(
      `/grade/add-new-grade/${userData.id}`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAllGradeSchemesViaAdmin = async () => {
  try {
    const response = await instance.get("/grade/get-all-gradeSchemes", {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getGradeSchemeByIdViaAdmin = async (id) => {
  try {
    const response = await instance.get(`/grade/get-gradeScheme/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const updateGradeSchemeViaAdmin = async (id, data) => {
  try {
    const response = await instance.put(
      `/grade/update-gradeScheme/${id}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const deleteGradeSchemeViaAdmin = async (id) => {
  try {
    const response = await instance.delete(`/grade/delete-gradeScheme/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// -----------------------------

// Admit Student
export const admitStudentViaAdmin = async (id, data) => {
  try {
    const response = await instance.post(`/students/admitStudent/${id}`, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const admitMultipleStudentsViaAdmin = async (data) => {
  try {
    const response = await instance.post("/students/admit-multiple", data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const startBulkAdmissionJob = async (data) => {
  try {
    const response = await instance.post("/students/admit-multiple", data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAdmissionJobStatus = async (jobId) => {
  try {
    const response = await instance.get(`/students/admission-job/${jobId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllAdmissionJobs = async () => {
  try {
    const response = await instance.get("/students/admission-jobs");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Cancel student admission
export const cancelStudentAdmissionViaAdmin = async (id) => {
  try {
    const response = await instance.patch(
      `/students/cancel-admission/${id}`,
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error canceling student admission:", error);
    throw error;
  }
};

// get all subjects of a batch
export const getAllSubjectsOfBatchViaAdmin = async (id) => {
  try {
    const response = await instance.get(
      `/batch/get-all-subjects-of-batch/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// get all students for a batch
export const getAllStudentsForABatchViaAdmin = async (batchName) => {
  try {
    const response = await instance.get(
      `/students/students-for-batch?batchName=${batchName}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// get all students
export const getAllStudentsViaAdmin = async (page = 1, filters = {}) => {
  try {
    const queryParams = new URLSearchParams({ page, ...filters }).toString();
    const response = await instance.get(`/students?${queryParams}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const downloadAllStudentsCSV = async (filters = {}) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const response = await instance.get(`/students/download?${queryParams}`, {
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const generateIdCards = async (studentIds) => {
  try {
    const response = await instance.post(
      "/students/generate-id-cards",
      { studentIds },
      {
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error generating ID cards:", error);
    throw error;
  }
};

export const startIdCardJob = async (studentIds) => {
  try {
    const response = await instance.post("/students/generate-id-cards", {
      studentIds,
    });
    return response.data;
  } catch (error) {
    console.error("Error starting ID card job:", error);
    throw error;
  }
};

export const getIdCardJobStatus = async (jobId) => {
  try {
    const response = await instance.get(`/students/generate-id-cards/status/${jobId}`);
    return response.data;
  } catch (error) {
    console.error("Error getting job status:", error);
    throw error;
  }
};

export const cancelIdCardJob = async (jobId) => {
  try {
    const response = await instance.delete(`/students/generate-id-cards/cancel/${jobId}`);
    return response.data;
  } catch (error) {
    console.error("Error canceling ID card job:", error);
    throw error;
  }
};

export const getStudentApplication = async (id) => {
  try {
    const response = await instance.get(`/form/get-single-application/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// update student marks

export const updateStudentMarksViaAdmin = async (marksData) => {
  try {
    const response = await instance.post(
      "/students/update-student-marks",
      marksData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error updating student marks:",
      error.response || error.message,
    );
    throw error;
  }
};

// add timetable to batch
export const addTimetableToBatchViaAdmin = async (id, timetableData) => {
  try {
    const response = await instance.put(
      `/batch/add-timetable-to-batch/${id}`, // PUT request as it's updating existing data
      { timetable: timetableData }, // Wrap timetableData inside a 'timetable' key
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`, // Use template literals for cleaner token insertion
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error adding timetable to batch:", error);
    throw error;
  }
};

export const fetchTimetableOfBatchViaAdmin = async (batchId) => {
  try {
    const response = await instance.get(
      `/batch/get-timetable-of-batch/${batchId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`, // Token for authentication
        },
      },
    );

    return response.data.timetable;
  } catch (error) {
    console.error("Error fetching timetable for batch:", error);
    throw error;
  }
};

// fetch all events
export const fetchAllEventsViaAdmin = async () => {
  try {
    const response = await instance.get("/events/get-all-events", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// create event
export const createEventViaAdmin = async (eventData) => {
  try {
    const response = await instance.post(
      "/events/create-new-event",
      eventData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// send mail
export const sendMailViaAdmin = async ({
  subject,
  message,
  recipientEmails,
}) => {
  try {
    const response = await instance.post(
      "/sendmail",
      { subject, message, recipientEmails },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// add feedback question
export const addQuestionViaAdmin = async ({ question, feedbackType }) => {
  try {
    const response = await instance.post(
      "/feedback/add-question",
      { question, feedbackType },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// remove feedback question
export const removeQuestionViaAdmin = async ({ question, feedbackType }) => {
  try {
    const response = await instance.put(
      "/feedback/remove-question",
      { question, feedbackType },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// get all feedback questions
export const getAllFacultyFeedbackQuestionsViaAdmin = async () => {
  try {
    const response = await instance.get("/feedback/get-faculty-questions", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// get all feedback questions
export const getAllSubjectFeedbackQuestionsViaAdmin = async () => {
  try {
    const response = await instance.get("/feedback/get-subject-questions", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// mark attendance via admin
export const markAttendanceViaAdmin = async ({
  batch,
  subjectId,
  date,
  attendance,
}) => {
  try {
    const response = await instance.post(
      "/attendance/mark-attendance",
      { batch, subjectId, date, attendance },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// fetch attendance via admin
export const fetchAttendanceViaAdmin = async ({ batchId, date, subjectId }) => {
  try {
    const response = await instance.get("/attendance/fetch-attendance", {
      params: { batchId, date, subjectId },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// assignments
export const createAssignment = async (data) => {
  try {
    console.log(data);
    const response = await instance.post("/assignments/create", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const removeAssignment = async (id) => {
  try {
    const response = await instance.delete(`/assignments/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchAssignmentsOfFaculty = async (id) => {
  try {
    const response = await instance.get(`/assignments/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchAssignmentsBySubject = async (subjectId, facultyId) => {
  try {
    const response = await instance.get(`/assignments/subject/${subjectId}/${facultyId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchStudentAssignments = async (batchId, subjectIds) => {
  try {
    const response = await instance.post(`/assignments/studentAssignments`, {
      batchId,
      subjectIds,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const submitAssignment = async (data) => {
  try {
    const response = await instance.post("/assignments/submit", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAssignmentSubmissions = async (assignmentId) => {
  try {
    const response = await instance.get(`/assignments/submissions/${assignmentId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStudentSubmissionStatus = async (assignmentId, studentId) => {
  try {
    const response = await instance.get(`/assignments/submission-status/${assignmentId}/${studentId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchAssignmentsOfBatch = async (batchId) => {
  try {
    const response = await instance.get(
      `/assignments/batchAssignments/${batchId}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// report card
export const getReportCard = async (studentId) => {
  try {
    const response = await instance.get(`/reportCard/${studentId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCertificateStatus = async (
  applicationId,
  certificateId,
  updateData,
) => {
  try {
    const response = await instance.put(
      `/form/verify-certificate/${applicationId}/${certificateId}`,
      updateData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const rejectApplicationViaAdmin = async (id, data) => {
  try {
    console.log(id, data);
    const response = await instance.post(
      `/form/reject-application/${id}`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const uploadStudentDataViaAdmin = async (data) => {
  try {
    const response = await instance.post(`/students/upload-csv`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const uploadFacultyDataViaAdmin = async (data) => {
  try {
    const response = await instance.post(`/faculty/upload-csv`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const uploadSubjectDataViaAdmin = async (data) => {
  try {
    const response = await instance.post(`/subject/upload-csv`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Fee Management APIs
export const getStudentFeeData = async (academicYear) => {
  try {
    const response = await instance.get(`/fees/student/${academicYear}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("studentToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createStudentFeeCheckout = async (paymentData) => {
  try {
    const response = await instance.post(
      "/payments/student-fee/create-checkout",
      paymentData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("studentToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStudentReceipts = async (academicYear) => {
  try {
    const response = await instance.get(
      `/receipts/student?academicYear=${academicYear}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("studentToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllTransactions = async () => {
  try {
    const response = await instance.get(`/receipts/alltransactions`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Admin Fee Management APIs
export const createFeeStructure = async (feeData) => {
  try {
    const response = await instance.post("/fees/structure", feeData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllFeeStructures = async () => {
  try {
    const response = await instance.get("/fees/structures", {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const controlPaymentAcceptance = async (feeStructureId, controlData) => {
  try {
    const response = await instance.put(
      `/fees/control/${feeStructureId}`,
      controlData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateFeeStructure = async (feeStructureId, feeData) => {
  try {
    const response = await instance.put(
      `/fees/structure/${feeStructureId}`,
      feeData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createRubricsSubjectViaAdmin = async (data) => {
  try {
    const response = await instance.post(
      "/rubrics-subjects/create-new-rubrics-subject",
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error creating rubrics subject:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const getAllRubricsSubjectsViaAdmin = async () => {
  try {
    const response = await instance.get(
      "/rubrics-subjects/get-all-rubrics-subjects",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching rubrics subjects:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const getRubricsSubjectByIdViaAdmin = async (id) => {
  try {
    const response = await instance.get(
      `/rubrics-subjects/get-rubrics-subject/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching rubrics subject:",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export const uploadStudentAttendance = async (records) => {
  return await instance.post("/attendance/student/upload", { records });
};

export const fetchStudentAttendance = async () => {
  return await instance.get("/attendance/student/all");
};

export const clearStudentAttendance = async () => {
  return await instance.delete("/attendance/student/clear");
};

// GroupbyStudents API functions
export const createGroupViaAdmin = async (groupData) => {
  try {
    console.log("Sending group data to API:", groupData);
    const adminToken = localStorage.getItem("adminToken");
    console.log("Admin token exists:", !!adminToken);
    console.log(
      "Admin token:",
      adminToken ? adminToken.substring(0, 20) + "..." : "null",
    );

    const response = await instance.post("/groupby-students", groupData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + adminToken,
      },
    });
    console.log("API response:", response.data);
    return response.data;
  } catch (error) {
    console.error("API error details:", error.response?.data || error.message);
    throw error;
  }
};

export const getGroupsBySubjectViaAdmin = async (subjectId) => {
  try {
    const response = await instance.get(
      `/groupby-students/subject/${subjectId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllGroupsViaAdmin = async (token) => {
  try {
    const authToken = token || localStorage.getItem("adminToken");
    if (!authToken) {
      throw new Error("No admin or faculty token found");
    }
    const response = await instance.get("/groupby-students", {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + authToken,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateGroupViaAdmin = async (groupId, groupData) => {
  try {
    const response = await instance.put(
      `/groupby-students/${groupId}`,
      groupData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("adminToken"),
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteGroupViaAdmin = async (groupId) => {
  try {
    const response = await instance.delete(`/groupby-students/${groupId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getStudentsForRandomSelectionViaAdmin = async () => {
  try {
    const response = await instance.get("/groupby-students/students/random", {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const downloadApplicationsCsv = async (filters) => {
  try {
    const queryParams = new URLSearchParams(filters).toString();
    const response = await instance.get(`/form/download-csv?${queryParams}`, {
      responseType: "blob", // Important for file downloads
      headers: {
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAllBatchesAPI = () => instance.get("/batch/get-all-batches");
export const getSubjectsByBatchAPI = (batchId) =>
  instance.get(`/batch/get-all-subjects-of-batch/${batchId}`);
export const getStudentsByBatchAPI = (batchId) =>
  instance.get(`/students/batch/${batchId}`);
export const updateStudentMarksAPI = (data) =>
  instance.post("/students/update-student-marks", data);
export const downloadMarksCSVTemplateAPI = (batchId, subjectId) =>
  instance.get(`/students/marks-csv-template/${batchId}/${subjectId}`, {
    responseType: "blob",
  });
export const bulkUpdateMarksFromCSVAPI = (subjectId, formData) =>
  instance.post(`/students/bulk-update-marks/${subjectId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const calculateSgpaAPI = (studentId) =>
  instance.get(`/reportCard/sgpa/${studentId}`);
export const toggleMarksVisibilityAPI = (batchId, marksVisible) =>
  instance.put(`/batch/toggle-marks-visibility/${batchId}`, { marksVisible });
export const getMyMarksAPI = () => instance.get("/students/my-marks");

// Notes API
export const uploadNote = async (formData) => {
  const response = await instance.post(`/notes/upload`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const getFacultyNotes = async () => {
  const response = await instance.get(`/notes/faculty`);
  return response.data;
};

export const getNotes = async (batchId, subjectId) => {
  const response = await instance.get(`/notes/${batchId}/${subjectId}`);
  return response.data;
};

export const deleteNote = async (id) => {
  const response = await instance.delete(`/notes/${id}`);
  return response.data;
};

export const getFacultyDetails = async () => {
  const response = await instance.get(`/faculty/my-details`);
  return response.data;
};

export const getStudentNotes = async () => {
  const response = await instance.get(`/students/my-notes`);
  return response.data;
};

export const getStudentsBySubject = async (subjectId) => {
  return await instance.get(`/students/subjects/${subjectId}`);
};

export const downloadMarksTemplate = async (subjectId) => {
  const response = await instance.get(
    `/students/subjects/${subjectId}/marks-template`,
    {
      responseType: "blob",
    },
  );
  const blob = new Blob([response.data], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = url;
  a.download = `marks-template-${subjectId}.csv`;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  return response;
};

export const uploadMarks = async (subjectId, formData) => {
  return await instance.post(
    `/students/subjects/${subjectId}/upload-marks`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

export const updateStudentDetailsViaAdmin = async (id, data) => {
  try {
    const response = await instance.patch(`/students/update-student/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateStudentPhotoAndSignViaAdmin = async (id, data) => {
  try {
    const response = await instance.post(
      `/students/update-photo-sign/${id}`,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const resetStudentPasswordViaAdmin = async (
  id,
  email = null,
  type = "reset",
) => {
  try {
    const response = await instance.post(`/students/reset-password/${id}`, {
      email,
      type,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

//----------------------- INSTALLMENT SETTINGS API -----------------------
export const getAllInstallmentSettingsViaAdmin = async () => {
  try {
    const response = await instance.get("/payments/get-all-installment-settings", {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSingleInstallmentSettingViaAdmin = async (userData) => {
  try {
    const response = await instance.get(`/payments/get-installment-setting/${userData.id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createInstallmentSettingViaAdmin = async (userData) => {
  try {
    const response = await instance.post("/payments/create-installment-setting", userData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const UpdateInstallmentSettingViaAdmin = async (userData) => {
  try {
    const response = await instance.put(`/payments/update-installment-setting/${userData.id}`, userData, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteInstallmentSettingViaAdmin = async (userData) => {
  try {
    const response = await instance.delete(`/payments/delete-installment-setting/${userData.id}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const toggleInstallmentSettingViaAdmin = async (userData) => {
  try {
    const response = await instance.patch(`/payments/toggle-installment-setting/${userData.id}`, {}, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getInstallmentOptionsForProgram = async (programId, paymentType = "application") => {
  try {
    const response = await instance.get(`/payments/installment-options/${programId}/${paymentType}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ---------------- ATKT PAYMENT / RECEIPT APIS ----------------
export const getAllAtktPaymentsViaAdmin = async () => {
  try {
    const response = await instance.get(`/receipts/atkt/payments`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("adminToken"),
      },
    });
    return response.data;
  } catch (error) { throw error; }
};

export const getAtktReceipt = async (atktFormId) => {
  try {
    const response = await instance.get(`/receipts/atkt/receipt/${atktFormId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + (localStorage.getItem("studentToken") || localStorage.getItem("adminToken")),
      },
    });
    return response.data;
  } catch (error) { throw error; }
};